import { Button, Card, Col, Divider, Flex, Form, Input, Modal, Popconfirm, Row, Select, Space, Switch, Typography } from "antd";
import { Blocker, Link, useBlocker, useLoaderData, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectSubmitStatus } from "./userSlice";
import { selectConsts } from "../home/homeSlice";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, SettingOutlined, UndoOutlined } from "@ant-design/icons";
import { addUser, updateUserById } from "./userThunk";
import { useEffect, useState } from "react";
import RoutePath from "../../app/routing/routes.path";
import { Wrapper, WrapperBody, WrapperHeader } from "../../app/components/myStyledComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const FormFieldLayout = {
    md: 18,
    span: 24
}

type MODE = 'add' | 'edit' | 'view';

export default function UpsertUser() {
    const user: any = useLoaderData();
    const {mode} = useParams();

    const [formDirty, setFormDirty] = useState(false);
    
    let [formRef] = Form.useForm();
    const iconInput = Form.useWatch('icon', formRef);
    
    let dispatch = useAppDispatch();
    
    let submitStatus = useAppSelector(selectSubmitStatus);

    let navigate = useNavigate();
    
    let blocker: any = useBlocker(
        ({ currentLocation, nextLocation }) =>
            formDirty && submitStatus != 'success'
            && currentLocation.pathname !== nextLocation.pathname
    );
    
    useEffect(() => {
    }, [])

    useEffect(()=>{
        if (user) {
            setFormData();
        }
    }, [user]);

    function setMode(value: MODE, id?: string) {
        if (id || user) {
            navigate(`${RoutePath.user}/${value}/${id || user.data._id}`)
        } else {
            navigate(`${RoutePath.user}/${value}`)
        }
    }

    function setFormData() {
        formRef.setFieldsValue(user.data);
        formRef.setFieldValue('deviceType', user?.data?.deviceType?._id);
        setFormDirty(false);
    }

    async function onFinish(values: any) {
        console.log('Success:', values);
        let savedData:any;
        if (user) {
            savedData = await dispatch(updateUserById({ id: user.data._id, body: values }))
        } else {
            savedData = await dispatch(addUser(values));
        }
        if (!savedData.error) {
            setMode('view', savedData.payload._id);
        }
    }

    function onFinishFailed(errorInfo: any) {
        console.log('Failed:', errorInfo);
    }

    function resetForm() {
        if (user) {
            setFormData();
        } else {
            formRef.resetFields()
        }
        setFormDirty(false);
    }

    function getTitle() {
        switch (mode){
            case 'add':
                return "Add New User"
            case 'edit':
                return "Update User"
            case 'view':
                return "View User"
        }
    }

    return (<Wrapper>
        <WrapperHeader>
            <Flex justify="space-between" align="center">
                <Typography.Title level={3}>
                    {getTitle()}
                </Typography.Title>
                <Space.Compact >
                    {(mode != 'view') ? <>
                        <Popconfirm
                            title="Reset form data"
                            description="Are you sure you want reset all changes?"
                            placement="bottomRight"
                            onConfirm={resetForm}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button icon={<UndoOutlined />} disabled={!formDirty}>Reset</Button>
                        </Popconfirm>
                        <Button
                            type="primary"
                            iconPosition="end"
                            icon={<CheckOutlined />}
                            onClick={formRef.submit}
                            loading={submitStatus == 'submitting'}>
                            {!user ? "Submit" : "Update"}
                        </Button></> : <>
                        {/* <Link to={RoutePath.userConfig}>
                            <Button
                                iconPosition="start"
                                icon={<SettingOutlined />}>
                                Configure
                            </Button>
                        </Link> */}
                        <Button
                            type="primary"
                            iconPosition="end"
                            icon={<EditOutlined />}
                            onClick={() => setMode('edit')}>
                            Edit
                        </Button>
                    </>
                    }
                </Space.Compact>
            </Flex>
            
        </WrapperHeader>
        <Divider />
        <WrapperBody>
            <Form
                {...layout}
                form={formRef}
                initialValues={{ isActive: true }}
                name="DeviceTypeForm"
                disabled={submitStatus == 'submitting' || mode == 'view'}
                onChange={()=>setFormDirty(true)}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <Row>
                    <Col {...FormFieldLayout}>
                        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col {...FormFieldLayout}>
                        <Form.Item name="mobile" label="Mobile No" rules={[
                            { required: true, message: "Please input mobile number" },
                            { pattern: /^[0-9]{10,15}$/, message: "Enter a valid mobile number" }
                        ]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col {...FormFieldLayout}>
                        <Form.Item name="email" label="Email" rules={[
                            { required: true, message: "Please input email" },
                            { type: "email", message: "Enter a valid email" }
                        ]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    {/* <Col {...FormFieldLayout}>
                        <Form.Item name="profilePic" label="Profile Pic">
                            <Input />
                        </Form.Item>
                    </Col> */}
                    <Col {...FormFieldLayout}>
                        <Form.Item name="active" label="Active" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </WrapperBody>
        <Modal
            title="Are you sure you want to leave?"
            open={blocker.state === "blocked"}
            onOk={() => blocker.proceed()}
            onCancel={() => blocker.reset()} />
    </Wrapper>)
}